import React from 'react';
import { Chip,Tooltip,withStyles,makeStyles } from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import moment from 'moment';
import { FruitPropsType } from 'src/views/harvesting/fruit-profile/model';

const useStyles = makeStyles((theme) => ({
  chip: {
    marginLeft: theme.spacing(0.5),
  },
  icon: {
    marginRight: '-8px !important',
    fontSize: 12,
  },
}));

function createdAtFormatLl(seconds:number|null) {
  return seconds
    ? moment(seconds * 1000).format('ll')
    : 'Before Feb, 2021';
}
interface FishManGroupType {
  fruit: FruitPropsType;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  checkedData:FruitPropsType|false;
}
export const FishmanGroup: React.FC<FishManGroupType> = ({ fruit, checkedData}) => {
  const classes = useStyles();
  if (checkedData&& checkedData.fishermans&&checkedData.fishermans.length>0) {
 
    return (
      <>
      
        Fishman:{' '}
        <HtmlTooltip
          placement="top"
          title={<>{createdAtFormatLl(checkedData.fishermans[0].createdAt.seconds)}</>}
          arrow
        >
          <Chip
            size="small"
            label={checkedData.fishermans[0].name}
            className={classes.chip}
          />
        </HtmlTooltip>
        {!!(checkedData.fishermans.length>1) && (
          <HtmlTooltip
            placement="top"
            title={
              <>
                {checkedData.fishermans
                  .slice(1)
                  .map((x,key) => (
                    <div key={key}>
                      <strong>{x.name}</strong>:{' '}
                      {createdAtFormatLl(x.createdAt.seconds)} <br />
                    </div>
                  )
                  )}
              </>
            }
            arrow
          >
            <Chip
              size="small"
              avatar={<PersonIcon className={classes.icon} />}
              label={<>{checkedData.fishermans.length - 1}+</>}
              className={classes.chip}
            />
          </HtmlTooltip>
        )}
        <br />
      </>
    );
  }
  return <></>;
};

const HtmlTooltip = withStyles((theme) => ({
  tooltipPlacementTop: {
    margin: '1px 0',
  },
  tooltip: {
    backgroundColor: '#272c34',
    // color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip);

